import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Heading } from '../../../../components/ui/Heading'
import { getColors } from '../../utils'

export default function TalentMatchSuggestions({
  title,
  description,
  talents = []
}) {
  return (
    <div className='w-full max-w-md rounded-lg border border-lightGrey bg-[#F7F9FE] p-4'>
      <Heading level={5}>{title}</Heading>
      <div className='mt-1'>
        <p className='text-sm font-normal'>{description}</p>
        <div className='mt-1 flex flex-col gap-y-3 pt-4'>
          {talents.map((talent) => (
            <button
              onClick={() => talent.onTalentClick(talent)}
              key={`talent-${talent.matchScore}-${talent.name}-${talent.id}`}
              className='flex flex-row items-center'
            >
              <div
                style={{
                  backgroundColor: getColors({ score: talent.matchScore })
                    .light,
                  color: getColors({ score: talent.matchScore }).dark
                }}
                className={clsx(
                  'flex h-8 w-12 items-center justify-center rounded text-sm font-medium'
                )}
              >
                {Math.round(talent.matchScore)}
              </div>
              <div className='ml-3 flex flex-col items-start'>
                <span
                  className={'text-sm font-medium text-buttonSecondaryBlue'}
                >
                  {talent.name}
                </span>
                <span className='text-sm font-normal text-gray-500'>{`Talent-ID: ${talent.talentId}`}</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

TalentMatchSuggestions.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  talents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      talentId: PropTypes.string.isRequired,
      matchScore: PropTypes.number.isRequired
    })
  ).isRequired,
  onTalentClick: PropTypes.func
}
